// extracted by mini-css-extract-plugin
export default {"blogText":"Blog_blogText__ZtijW","blogs":"Blog_blogs__Qv08D","image":"Blog_image__3+4uo","blog":"Blog_blog__xSjWV","blogTitle":"Blog_blogTitle__54eA8","button":"Blog_button__CoZ51"};